export default __webpack_public_path__ + "static/media/IMG-20240729-WA0032.d8c4b256.jpg";